Backbone = if not window? and module? then require('backbone') else window.Backbone

_.mixin
	shuffled: (array) -> @sortBy array, (el) -> 0.5 - Math.random()

	beget: (obj) ->
		ctor = ->
		ctor.prototype = obj
		return new ctor()

	#Extend only the attributes specified
	extendAttrs: (obj, attrs, extendWith...) ->
		_.each extendWith, (source) ->
			for prop of source when _.contains attrs, prop
				obj[prop] = source[prop]
		return obj;

escapeSelector = (id) -> id.replace /([\.:])/g, "\\$1"

randomString = (len = 10) ->
	chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'

	return (chars[Math.floor(Math.random() * chars.length)] for i in [0...len]).join('')

CSV =
	Writer: class CSVWriter
		constructor: ->
			@buffer = []

		encodeCell: (value) -> '"' + (value ? "").replace(/\"/g, '""') + '"'

		writeRow: (row) ->
			@buffer.push (@encodeCell cell for cell in row).join(",")

		getText: -> @buffer.join("\n")

		getEncoded: -> base64.encode @getText()

		getUri: ->
			safari = navigator.userAgent.indexOf('Safari') >= 0 and navigator.userAgent.indexOf('Chrome') == -1
			chrome = navigator.userAgent.indexOf('Chrome') >= 0
			if safari
				"data:application/csv;base64," + @getEncoded()
			else if chrome
				"data:application/octet-stream;base64," + @getEncoded()
			else
				"data:text/csv;base64," + @getEncoded()

	parse: (text, delimiter = ',') ->
		pattern = new RegExp(
			# delimiters
			"(\\#{delimiter}|\\r?\\n|\\r|^)" +
			# quoted fields
			"(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
			# standard fields
			"([^\"\\#{delimiter}\\r\\n]*))", "gi")

		data = [[]]

		while (matches = pattern.exec text)
			# check for a new row
			if matches[1].length and matches[1] != delimiter
				data.push []

			if matches[2]
				cell = matches[2].replace(new RegExp("\"\"", "g"), "\"")
			else
				cell = matches[3] ? ""

			data[data.length - 1].push cell

		return data

class trans
	language: 'en'
	defaultLanguage: 'en'
	availableLanguages: ['en']

	@first: (obj) ->
		for own k, v of obj
			return v

	toString: (lang=@language) -> this[lang] ? trans.first(this) ? ''

	toJSON: ->
		return '' if _.size(this) == 0

		return trans.first(this) if _.size(this) == 1

		result = {}

		result[@defaultLanguage] = this[@defaultLanguage] if @defaultLanguage of this

		for own lang of this
			result[lang] = this[lang] if lang in @availableLanguages

		return result

	constructor: (obj) ->
		if typeof obj == 'string'
			this[@language] = obj
		else if obj?
			this[@defaultLanguage] = obj[@defaultLanguage] if @defaultLanguage of obj
			for own lang of obj
				this[lang] = obj[lang]

	@make: (obj) -> new trans obj

	@localizedDropdown: ->
		dropdown = $('<select name="l"/>')

		for lang in @::availableLanguages
			option = $("<option value=\"#{lang}\">#{LANGUAGES[lang]}</option>")
			option.attr('selected', 'selected') if @::language == lang
			dropdown.append option

		return dropdown

class Choice extends Backbone.Model
	constructor: (index, info) ->
		rightLabel = info.rightLabel ? info.rlabel
		super
			id: info.id ? index
			label: trans.make info.label
			score: info.score
			other: info.other
			na: info.na ? undefined
			check_all: info.check_all ? undefined
			required: info.required
			other_required: info.other_required?
			type: info.type
			appearance: info.appearance
			columns: info.columns ? info.cols
			rows: info.rows
			choices: if info.choices? then Choice.makeList info.choices else undefined
			rightLabel: if rightLabel? then trans.make rightLabel else undefined
			validation: info.validation
			initialValue: info.initialValue
			static: info.static

	label: -> @get('label').toString()
	score: -> @get('score') ? (@id + 1)

	@makeList: (info) ->
		for i in [0...info.length]
			new this(i, info[i])

class Extraction
	constructor: (info) ->
		@source = info.question
		@options = info.options

	resolve: (survey) ->
		id = survey.resolveName @source

		source = survey.questions()[id]

		if not source?.getExtraction?
			console.warn "Extraction from invalid source [#{@source}], skipping..."
			return null

		@_source = source
		@choices = source.getExtraction(null, @options)

	labelForChoice: (id) ->
		if @choices[id].get('other')
			return "{{ COALESCE(#{@choices[id].get('other').get('name').replace(/\./g, '_')},'#{@choices[id].label()}') }}"
		@choices[id].label()

	evaluate: (handler) ->
		id = handler.survey.resolveName @source

		source = handler.survey.questions()[id]

		if not source?.getExtraction?
			console.warn "Extraction from invalid source [#{@source}], skipping..."
			return null

		result = {}

		for choice in source.getExtraction(handler.response, @options)
			result[choice.id] = true

		return result

	bind: (id) ->
		console.log 'BINDING:', this, id
		return this

module.exports = {
	randomString: randomString, 
	trans: trans,
	Choice: Choice
}